import Mmenu from './components/mobile_menu';

(function ($, Drupal) {
  Drupal.behaviors.amanbank = {
    attach: function (context, settings) {

      // Search toggle in top menu
      $('.region--header .search-btn', context).on('click', function(e) {
        e.preventDefault();
        $('.region--header .search-block-form', context).toggleClass('visually-hidden');
        $('.region--header .search-block-form .form-search', context).focus();
      });

      // Search toggle in top menu
      $('.region--header .lang-link', context).on('click', function(e) {
        e.preventDefault();
      });

      // Scroll to hash on load
      let hash = window.location.hash.substr(1);
      if ( hash !== "" ) {
        let anchor_offset = $('#' + hash, context).offset();
        if (typeof anchor_offset !== "undefined") {
          $('html, body').animate({
          scrollTop: (anchor_offset.top - 100)
          }, 'slow');
        }
      }

      // Main menu dropdown on touch devices
      let menu_items = document.querySelectorAll('.menu-item.has-children > a');
      for (let i = 0; i < menu_items.length; i++) {
        menu_items[i].addEventListener('touchstart', function(e) {
          e.preventDefault();
          this.parentElement.classList.toggle('parent-open');
        });
      }

      // Mobile menu
      new Mmenu('#mobile-menu', {
        // options
        navbars: [{
          content: [
            document.querySelector('.mobile-menu--header').outerHTML
          ]
        },{
          position: 'bottom',
          content: [
            document.querySelector('.mobile-menu--footer').outerHTML
          ]
        }],
        extensions: [
          'fullscreen'
        ]
      }, {
        // configuration
        offCanvas: {
          page: {
            selector: '#page-canvas'
          }
        }
      });
    }
  };
})(jQuery, Drupal);
